
export const QUERY_CRITERIA = "/public/query";

export const QUERY_CRITERIA_COUNT = "/public/count";

export const DOWNLOAD_FILE = "/public/file/view?isin=";
